import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from 'reactstrap';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import {
  filterBuildingsInitAction,
  updateBuildingsFiltersAction,
} from '../../../actions/instances/buildings';

const TagsViewer = ({
  tags,
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  return (
    <div>
      {tags && tags.map(tag => (
        <Badge
          color="primary"
          style={{ cursor: 'pointer' }}
          onClick={() => {
            if (location.pathname !== 'home') {
              history.push('/home');
              window.scrollTo(0, 0);
            }
            dispatch(updateBuildingsFiltersAction([{
              type: 'tag',
              value: tag.id,
              label: tag.name,
            }]));
            setTimeout(() => {
              dispatch(filterBuildingsInitAction());
            }, 500);
          }}
        >
          {tag.name}
        </Badge>
      ))}
    </div>
  );
};

TagsViewer.propTypes = {
  tags: PropTypes.array.isRequired,
};

TagsViewer.defaultProps = {

};

export default TagsViewer;
